import { render, staticRenderFns } from "./GameCreation.vue?vue&type=template&id=f71a2500&scoped=true"
import script from "./GameCreation.vue?vue&type=script&lang=js"
export * from "./GameCreation.vue?vue&type=script&lang=js"
import style0 from "./GameCreation.vue?vue&type=style&index=0&id=f71a2500&prod&lang=scss&scoped=true"
import style1 from "./GameCreation.vue?vue&type=style&index=1&id=f71a2500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71a2500",
  null
  
)

export default component.exports